import gql from "graphql-tag";

export const GET_PATIENT_ADDRESSES_LIST = gql`
  query GetPatientAddressList($patientId: String!) {
    getPatientAddressList(patientId: $patientId) {
      addressList {
        id
        addressLine1
        addressLine2
        city
        mobileNumber
        state
        zipcode
        landmark
        createdDate
        updatedDate
        addressType
        otherAddressType
        latitude
        longitude
        stateCode
        name
      }
    }
  }
`;
